import { render, staticRenderFns } from "./addPassenger.vue?vue&type=template&id=8ac33f34&scoped=true&"
import script from "./addPassenger.vue?vue&type=script&lang=js&"
export * from "./addPassenger.vue?vue&type=script&lang=js&"
import style0 from "./addPassenger.vue?vue&type=style&index=0&id=8ac33f34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac33f34",
  null
  
)

export default component.exports